/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown>, date: NonNullable<unknown> }} Scheduledchangedescription2Inputs */

const en_scheduledchangedescription2 = /** @type {(inputs: Scheduledchangedescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your plan changes to ${i?.tier} on ${i?.date}.`)
};

const de_scheduledchangedescription2 = /** @type {(inputs: Scheduledchangedescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein Plan wechselt am ${i?.date} zu ${i?.tier}.`)
};

/**
* | output |
* | --- |
* | "Your plan changes to {tier} on {date}." |
*
* @param {Scheduledchangedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const scheduledchangedescription2 = /** @type {((inputs: Scheduledchangedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scheduledchangedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_scheduledchangedescription2(inputs)
	return de_scheduledchangedescription2(inputs)
});
export { scheduledchangedescription2 as "scheduledChangeDescription" }